const n = {
  name: "WarningDiamond",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.9997 5.99994V11.9999H10.9997V5.99994H12.9997Z" fill="currentColor"/>
<path d="M11.9997 16.9999C12.8281 16.9999 13.4997 16.3284 13.4997 15.4999C13.4997 14.6715 12.8281 13.9999 11.9997 13.9999C11.1713 13.9999 10.4997 14.6715 10.4997 15.4999C10.4997 16.3284 11.1713 16.9999 11.9997 16.9999Z" fill="currentColor"/>
<path d="M9.87838 1.70705C11.05 0.535475 12.9494 0.535477 14.121 1.70705L22.2926 9.87862C23.4642 11.0502 23.4642 12.9497 22.2926 14.1213L14.121 22.2928C12.9494 23.4644 11.0499 23.4644 9.87838 22.2928L1.7068 14.1213C0.535231 12.9497 0.535233 11.0502 1.70681 9.87862L9.87838 1.70705ZM12.7068 3.12126C12.3163 2.73074 11.6831 2.73074 11.2926 3.12126L3.12102 11.2928C2.73049 11.6834 2.73049 12.3165 3.12102 12.707L11.2926 20.8786C11.6831 21.2691 12.3163 21.2691 12.7068 20.8786L20.8784 12.707C21.2689 12.3165 21.2689 11.6834 20.8784 11.2928L12.7068 3.12126Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as WarningDiamond
};
